import api from "./api";

const cache = {
  tms: new Map(),
  projectAssist: null
};

const normalizeKey = (value) =>
  value === undefined || value === null || value === "" ? "none" : String(value);

const buildTmsKey = (clientId, verticalIds) => {
  const clientKey = normalizeKey(clientId);
  const verticalKey = Array.isArray(verticalIds)
    ? [...new Set(verticalIds)].sort((a, b) => a - b).join(",")
    : "none";
  return `${clientKey}|${verticalKey}`;
};

const buildTmsParams = (clientId, verticalIds) => {
  const params = {};
  if (clientId !== null && clientId !== undefined && clientId !== "") {
    params.clientId = clientId;
  }

  if (Array.isArray(verticalIds) && verticalIds.length > 0) {
    params.verticalIds = verticalIds.join(",");
  }

  return params;
};

export async function getTmsProductionMetadata({
  clientId = null,
  verticalIds = []
} = {}) {
  const key = buildTmsKey(clientId, verticalIds);
  if (cache.tms.has(key)) {
    return cache.tms.get(key);
  }

  const response = await api.get("/api/production-metadata/tms", {
    params: buildTmsParams(clientId, verticalIds)
  });

  const payload = response.data || {};
  cache.tms.set(key, payload);
  return payload;
}

export async function getProjectAssistMetadata({ forceRefresh = false } = {}) {
  if (!forceRefresh && cache.projectAssist) {
    return cache.projectAssist;
  }

  const response = await api.get("/api/production-metadata/project-assist");
  cache.projectAssist = response.data || {};
  return cache.projectAssist;
}

export function clearProductionMetadataCache() {
  cache.tms.clear();
  cache.projectAssist = null;
}

export function clearTmsMetadataCache() {
  cache.tms.clear();
}

export function clearProjectAssistMetadataCache() {
  cache.projectAssist = null;
}
